import React, { useState } from 'react';

const mockClients = [
  { name: 'Jane Doe', subject: 'Mathematics', status: 'Active' },
  { name: 'John Smith', subject: 'Physics', status: 'Pending' },
];

const mockSessions = [
  { date: '2024-06-10', time: '3:00 PM', student: 'Jane Doe', subject: 'Mathematics' },
  { date: '2024-06-12', time: '5:00 PM', student: 'John Smith', subject: 'Physics' },
];

export default function TutorDashboard() {
  const [modal, setModal] = useState(null);
  const [resourceOpen, setResourceOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState([false, false, false]);
  const closeModal = () => setModal(null);
  return (
    <div className="dashboard-bg tutor-dashboard-bg">
      {/* Floating Resource Center Button */}
      <button className="resource-center-fab animate-fadein" onClick={() => setResourceOpen(true)} title="Resource Center">
        <img src="/zentora-transparent-white.png" alt="Resource Center" className="resource-center-logo" />
      </button>
      {/* Resource Center Sidebar */}
      {resourceOpen && (
        <div className="resource-center-overlay animate-fadein" onClick={() => setResourceOpen(false)}>
          <aside className="resource-center-sidebar animate-slidein rounded-sidebar" onClick={e => e.stopPropagation()}>
            <button className="resource-center-close" onClick={() => setResourceOpen(false)} title="Close">×</button>
            <div className="resource-center-header">
              <svg width="36" height="36" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#fff"/><path d="M10 13.5C10 12.1193 11.1193 11 12.5 11H19.5C20.8807 11 22 12.1193 22 13.5V18.5C22 19.8807 20.8807 21 19.5 21H12.5C11.1193 21 10 19.8807 10 18.5V13.5Z" fill="#a259ff" stroke="#4f8cff" strokeWidth="1.5"/><rect x="13" y="14" width="6" height="2" rx="1" fill="#fff"/><rect x="13" y="17" width="4" height="2" rx="1" fill="#fff"/></svg>
              <div>
                <h2>Resource Center</h2>
                <div className="resource-center-sub">Curated tools, tips, and AI-powered recommendations</div>
              </div>
            </div>
            <div className="resource-center-section">
              <h3 className="sans-header">Featured Resources</h3>
              <ul className="resource-list">
                <li><a href="#" target="_blank" rel="noopener">Tutor Best Practices (PDF)</a></li>
                <li><a href="#" target="_blank" rel="noopener">Video: Engaging Students Online</a></li>
                <li><a href="#" target="_blank" rel="noopener">FAQ & Troubleshooting</a></li>
                <li><a href="#" target="_blank" rel="noopener">How to Grow Your Client Base</a></li>
              </ul>
            </div>
            <div className="resource-center-section faq-section">
              <h3 className="sans-header">FAQ</h3>
              <div className="faq-list">
                <div className={`faq-item${faqOpen[0] ? ' open' : ''}`} onClick={() => setFaqOpen([!faqOpen[0], false, false])} tabIndex={0} role="button" aria-expanded={faqOpen[0]}>
                  <div className="faq-question">How do I schedule a new session?</div>
                  <div className="faq-answer">Click the "Schedule Session" button in the Quick Actions panel, select your client, date, and time, then confirm. The session will appear in your Upcoming Sessions.</div>
                </div>
                <div className={`faq-item${faqOpen[1] ? ' open' : ''}`} onClick={() => setFaqOpen([false, !faqOpen[1], false])} tabIndex={0} role="button" aria-expanded={faqOpen[1]}>
                  <div className="faq-question">Where can I upload my certificates?</div>
                  <div className="faq-answer">Use the "Upload Certificate" button in Quick Actions or the "Upload Supplementary Document" card to add new qualifications to your profile.</div>
                </div>
                <div className={`faq-item${faqOpen[2] ? ' open' : ''}`} onClick={() => setFaqOpen([false, false, !faqOpen[2]])} tabIndex={0} role="button" aria-expanded={faqOpen[2]}>
                  <div className="faq-question">How do I contact my clients?</div>
                  <div className="faq-answer">Click "Message Client" in Quick Actions to send a direct message to any of your assigned clients.</div>
                </div>
              </div>
            </div>
            <div className="resource-center-section ai-section">
              <h3 className="sans-header">Recommendations</h3>
              <div className="ai-recommendation-card">
                <span>Based on your recent sessions, we recommend: <b>"Advanced Engagement Techniques"</b></span>
              </div>
              <div className="ai-recommendation-card">
                <span>Try the <b>"Client Retention Masterclass"</b> to boost your repeat bookings.</span>
              </div>
            </div>
          </aside>
        </div>
      )}
      <div className="dashboard-header">
        <img src="/zentora-transparent-white.png" alt="Zentora Logo" className="dashboard-logo" />
        <h1 className="dashboard-title pp-editorial-italic">Tutor Dashboard</h1>
      </div>
      <div className="dashboard-content">
        {/* Quick Actions Panel */}
        <section className="dashboard-card quick-actions-card glassmorphism animate-fadein">
          <h2 className="dashboard-section-title sans-header">Quick Actions</h2>
          <div className="quick-actions-subtitle">Get started with common tasks</div>
          <div className="quick-actions-btn-row">
            <button className="quick-action-btn" onClick={() => setModal('schedule')}>
              <span className="quick-action-icon">
                {/* Calendar SVG */}
                <svg width="26" height="26" fill="none" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="5" fill="#fff" stroke="#a259ff" strokeWidth="1.5"/><rect x="7" y="9" width="10" height="2" rx="1" fill="#a259ff"/><rect x="7" y="13" width="6" height="2" rx="1" fill="#4f8cff"/></svg>
              </span>
              Schedule Session
            </button>
            <button className="quick-action-btn" onClick={() => setModal('message')}>
              <span className="quick-action-icon">
                {/* Message SVG */}
                <svg width="26" height="26" fill="none" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="5" fill="#fff" stroke="#a259ff" strokeWidth="1.5"/><rect x="7" y="11" width="10" height="2" rx="1" fill="#a259ff"/><circle cx="8.5" cy="9" r="1" fill="#4f8cff"/><circle cx="12" cy="9" r="1" fill="#4f8cff"/><circle cx="15.5" cy="9" r="1" fill="#4f8cff"/></svg>
              </span>
              Message Client
            </button>
            <button className="quick-action-btn" onClick={() => setModal('upload')}>
              <span className="quick-action-icon">
                {/* Upload SVG */}
                <svg width="26" height="26" fill="none" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="5" fill="#fff" stroke="#a259ff" strokeWidth="1.5"/><path d="M12 15V9M12 9l-3 3M12 9l3 3" stroke="#4f8cff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
              Upload Certificate
            </button>
            <button className="quick-action-btn" onClick={() => setModal('edit')}>
              <span className="quick-action-icon">
                {/* Edit SVG */}
                <svg width="26" height="26" fill="none" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="5" fill="#fff" stroke="#a259ff" strokeWidth="1.5"/><path d="M8 15l8-8M14 7l3 3" stroke="#4f8cff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
              Edit Profile
            </button>
          </div>
        </section>
        <section className="dashboard-card profile-card">
          <h2 className="dashboard-section-title sans-header">Your Profile</h2>
          <div className="profile-info">
            <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Avatar" className="profile-avatar" />
            <div>
              <div className="profile-name">Alex Johnson</div>
              <div className="profile-subjects">Subjects: Mathematics, Physics</div>
            </div>
          </div>
        </section>
        <section className="dashboard-card upload-card">
          <h2 className="dashboard-section-title sans-header">Upload Supplementary Document</h2>
          <input type="file" className="dashboard-file-input" />
          <button className="dashboard-btn">Upload</button>
        </section>
        <section className="dashboard-card clients-card">
          <h2 className="dashboard-section-title sans-header">Client Management</h2>
          <ul className="dashboard-list">
            {mockClients.map((client, i) => (
              <li key={i} className="dashboard-list-item">
                <span className="client-name">{client.name}</span>
                <span className="client-subject">{client.subject}</span>
                <span className={`client-status status-${client.status.toLowerCase()}`}>{client.status}</span>
              </li>
            ))}
          </ul>
        </section>
        <section className="dashboard-card sessions-card">
          <h2 className="dashboard-section-title sans-header">Upcoming Sessions</h2>
          <ul className="dashboard-list">
            {mockSessions.map((session, i) => (
              <li key={i} className="dashboard-list-item">
                <span className="session-date">{session.date}</span>
                <span className="session-time">{session.time}</span>
                <span className="session-student">{session.student}</span>
                <span className="session-subject">{session.subject}</span>
              </li>
            ))}
          </ul>
        </section>
        {/* Academic Intelligence Dashboard */}
        <section className="dashboard-card analytics-card glassmorphism animate-fadein">
          <div className="analytics-header analytics-header-center">
            <div className="analytics-header-center-group">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#fff"/><path d="M10 22V14.5C10 13.1193 11.1193 12 12.5 12H19.5C20.8807 12 22 13.1193 22 14.5V22" stroke="#a259ff" strokeWidth="1.5"/><rect x="13" y="16" width="2" height="5" rx="1" fill="#a259ff"/><rect x="17" y="18" width="2" height="3" rx="1" fill="#4f8cff"/></svg>
              <h2 className="pp-editorial-italic">Academic Intelligence Dashboard</h2>
            </div>
          </div>
          <div className="analytics-charts-row">
            <div className="analytics-chart interactive-chart" tabIndex="0" title="View session trends">
              <div className="chart-title">Session Trends</div>
              <svg viewBox="0 0 120 48">
                <defs>
                  <linearGradient id="lineGrad" x1="0" y1="0" x2="120" y2="0" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#a259ff"/>
                    <stop offset="1" stopColor="#4f8cff"/>
                  </linearGradient>
                </defs>
                <polyline points="0,40 20,30 40,35 60,18 80,22 100,10 120,20" fill="none" stroke="url(#lineGrad)" strokeWidth="4" strokeLinecap="round"/>
                <circle cx="100" cy="10" r="5" fill="#4f8cff"/>
                <circle cx="120" cy="20" r="5" fill="#a259ff"/>
              </svg>
              <div className="chart-label">+32% this month</div>
            </div>
            <div className="analytics-chart interactive-chart" tabIndex="0" title="View client growth">
              <div className="chart-title">Client Growth</div>
              <svg viewBox="0 0 60 48">
                <defs>
                  <linearGradient id="barGrad" x1="0" y1="0" x2="60" y2="0" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#a259ff"/>
                    <stop offset="1" stopColor="#4f8cff"/>
                  </linearGradient>
                </defs>
                <rect x="6" y="28" width="10" height="14" rx="3" fill="#a259ff"/>
                <rect x="22" y="18" width="10" height="24" rx="3" fill="#4f8cff"/>
                <rect x="38" y="8" width="10" height="34" rx="3" fill="url(#barGrad)"/>
              </svg>
              <div className="chart-label">+5 new clients</div>
            </div>
            <div className="analytics-chart interactive-chart" tabIndex="0" title="View subject popularity">
              <div className="chart-title">Subject Popularity</div>
              <svg className="chart-pie" viewBox="0 0 56 56">
                <defs>
                  <linearGradient id="pieGrad" x1="0" y1="0" x2="56" y2="0" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#4f8cff"/>
                    <stop offset="1" stopColor="#a259ff"/>
                  </linearGradient>
                </defs>
                <circle cx="28" cy="28" r="24" fill="#f3f3f7"/>
                <path d="M28 28 L28 4 A24 24 0 0 1 52 28 Z" fill="#a259ff"/>
                <path d="M28 28 L52 28 A24 24 0 1 1 28 4 Z" fill="url(#pieGrad)"/>
              </svg>
              <div className="chart-label">Math 60% • Physics 40%</div>
            </div>
          </div>
          <div className="analytics-insights">
            <div className="insights-title">Insights</div>
            <ul className="insights-list">
              <li><span className="insight-glow"></span>Your next month’s top subject will be <b>Physics</b>.</li>
              <li><span className="insight-glow"></span>You’re in the <b>top 10%</b> for client retention.</li>
              <li><span className="insight-glow"></span>AI suggests offering a <b>group session</b> for higher engagement.</li>
            </ul>
          </div>
        </section>
      </div>
      {/* Modals for Quick Actions */}
      {modal && (
        <div className="dashboard-modal-overlay animate-fadein" onClick={closeModal}>
          <div className="dashboard-modal animate-pop" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeModal}>×</button>
            {modal === 'schedule' && (
              <div>
                <h3>Schedule New Session</h3>
                <p>(Demo) Select date, time, and client to schedule a session.</p>
                <div className="modal-form-row">
                  <input type="date" className="zentora-input" />
                  <input type="time" className="zentora-input" />
                  <select className="zentora-input">
                    <option>Jane Doe</option>
                    <option>John Smith</option>
                  </select>
                  <button className="zentora-btn modal-action-btn">Schedule</button>
                </div>
              </div>
            )}
            {modal === 'message' && (
              <div>
                <h3>Message Client</h3>
                <p>(Demo) Send a quick message to your client.</p>
                <div className="modal-form-row">
                  <select className="zentora-input">
                    <option>Jane Doe</option>
                    <option>John Smith</option>
                  </select>
                </div>
                <textarea rows={3} placeholder="Type your message..." className="zentora-input" style={{width:'100%',marginTop:8}} />
                <button className="zentora-btn modal-action-btn">Send</button>
              </div>
            )}
            {modal === 'upload' && (
              <div>
                <h3>Upload Certificate</h3>
                <p>(Demo) Upload a new certificate or qualification document.</p>
                <input type="file" className="zentora-input" />
                <button className="zentora-btn modal-action-btn">Upload</button>
              </div>
            )}
            {modal === 'edit' && (
              <div>
                <h3>Edit Profile</h3>
                <p>(Demo) Update your profile information.</p>
                <input type="text" placeholder="Name" defaultValue="Alex Johnson" className="zentora-input" style={{width:'100%',marginBottom:8}} />
                <input type="text" placeholder="Subjects" defaultValue="Mathematics, Physics" className="zentora-input" style={{width:'100%',marginBottom:8}} />
                <button className="zentora-btn modal-action-btn">Save Changes</button>
              </div>
            )}
          </div>
        </div>
      )}
      <style jsx>{`
        .dashboard-bg {
          min-height: 100vh;
          background: linear-gradient(120deg, #f3f3f7 0%, #e9e6ff 100%);
          font-family: 'FK Grotesk', sans-serif;
          padding: 0 0 60px 0;
        }
        .dashboard-header {
          display: flex;
          align-items: center;
          gap: 18px;
          padding: 48px 0 24px 0;
          justify-content: center;
        }
        .dashboard-logo {
          width: 64px;
          height: 64px;
          object-fit: contain;
          filter: drop-shadow(0 8px 32px #a259ff44) drop-shadow(0 0 12px #fff8);
        }
        .dashboard-title {
          font-family: 'PP Editorial New Italic', 'PP Editorial', serif;
          font-size: 2.6rem;
          color: #23273a;
          letter-spacing: -0.03em;
          font-style: italic;
        }
        .pp-editorial-italic {
          font-family: 'PP Editorial New Italic', 'PP Editorial', serif;
          font-style: italic;
        }
        .dashboard-content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
          gap: 32px;
          max-width: 1200px;
          margin: 0 auto;
        }
        .dashboard-card {
          background: rgba(255,255,255,0.92);
          border-radius: 18px;
          box-shadow: 0 8px 40px #a259ff18, 0 0 0 2px #4f8cff11;
          padding: 32px 28px 24px 32px;
          display: flex;
          flex-direction: column;
          gap: 18px;
        }
        .dashboard-section-title {
          font-family: 'FK Grotesk', sans-serif;
          font-size: 1.32rem;
          color: #4f8cff;
          margin-bottom: 12px;
          font-weight: 800;
          letter-spacing: -0.01em;
        }
        .sans-header {
          font-family: 'FK Grotesk', sans-serif !important;
          font-style: normal !important;
          font-weight: 800;
          letter-spacing: -0.01em;
        }
        .profile-info {
          display: flex;
          align-items: center;
          gap: 18px;
        }
        .profile-avatar {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          object-fit: cover;
          border: 2.5px solid #a259ff;
        }
        .profile-name {
          font-size: 1.2rem;
          font-weight: 600;
          color: #23273a;
        }
        .profile-subjects {
          color: #8a8e9c;
          font-size: 1.01rem;
        }
        .dashboard-file-input {
          margin-bottom: 10px;
        }
        .dashboard-btn {
          font-family: 'FK Grotesk', sans-serif;
          background: #bbaaff;
          color: #fff;
          border: 1.5px solid #e0dfff;
          border-radius: 10px;
          font-size: 1rem;
          font-weight: 600;
          padding: 10px 28px;
          cursor: pointer;
          box-shadow: 0 4px 18px #a259ff22;
          transition: background 0.2s, transform 0.2s;
        }
        .dashboard-btn:hover {
          background: #a084e8;
          transform: translateY(-2px) scale(1.04);
        }
        .dashboard-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .dashboard-list-item {
          display: flex;
          align-items: center;
          gap: 18px;
          background: #f3f3f7;
          border-radius: 8px;
          padding: 12px 18px;
          font-size: 1.01rem;
        }
        .client-name, .session-student {
          font-weight: 600;
          color: #23273a;
        }
        .client-subject, .session-subject {
          color: #8a8e9c;
        }
        .client-status {
          margin-left: auto;
          font-weight: 600;
          padding: 4px 12px;
          border-radius: 8px;
        }
        .status-active {
          background: #e6f7ee;
          color: #30d158;
        }
        .status-pending {
          background: #f7f3e6;
          color: #a259ff;
        }
        .session-date {
          color: #4f8cff;
          font-weight: 600;
        }
        .session-time {
          color: #a259ff;
        }
        .quick-actions-card {
          grid-column: 1 / -1;
          background: rgba(255,255,255,0.55);
          box-shadow: 0 8px 40px #a259ff22, 0 0 0 2px #4f8cff11;
          backdrop-filter: blur(16px) saturate(1.2);
          border: 1.5px solid #e9e6ff88;
          padding-top: 32px;
          padding-bottom: 32px;
          position: relative;
          overflow: hidden;
          animation: fadein 0.7s cubic-bezier(.4,0,.2,1);
        }
        .glassmorphism {
          background: rgba(255,255,255,0.55);
          box-shadow: 0 8px 40px #a259ff22, 0 0 0 2px #4f8cff11;
          backdrop-filter: blur(16px) saturate(1.2);
          border: 1.5px solid #e9e6ff88;
        }
        .quick-actions-subtitle {
          color: #8a8e9c;
          font-size: 1.08rem;
          margin-bottom: 18px;
          margin-top: -8px;
        }
        .quick-actions-btn-row {
          display: flex;
          gap: 24px;
          flex-wrap: wrap;
          justify-content: flex-start;
        }
        .quick-action-btn {
          font-family: 'FK Grotesk', sans-serif;
          display: flex;
          align-items: center;
          gap: 12px;
          background: #bbaaff;
          color: #fff;
          border: 1.5px solid #e0dfff;
          border-radius: 14px;
          font-size: 1.13rem;
          font-weight: 600;
          padding: 18px 32px;
          cursor: pointer;
          box-shadow: 0 4px 18px #a259ff22, 0 1.5px 0 #fff8 inset;
          transition: background 0.18s, transform 0.18s, box-shadow 0.18s;
          position: relative;
          outline: none;
        }
        .quick-action-btn:active {
          transform: scale(0.97);
          box-shadow: 0 2px 8px #a259ff22;
        }
        .quick-action-btn:hover, .quick-action-btn:focus {
          background: #a084e8;
          transform: translateY(-2px) scale(1.045);
          box-shadow: 0 8px 32px #a259ff22, 0 1.5px 0 #fff8 inset;
        }
        .quick-action-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px #a259ff11;
          padding: 4px;
          margin-right: 2px;
        }
        /* Animations */
        @keyframes fadein {
          from { opacity: 0; transform: translateY(24px) scale(0.98); }
          to { opacity: 1; transform: none; }
        }
        .animate-fadein {
          animation: fadein 0.7s cubic-bezier(.4,0,.2,1);
        }
        @keyframes pop {
          from { opacity: 0; transform: scale(0.92); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-pop {
          animation: pop 0.35s cubic-bezier(.4,0,.2,1);
        }
        .dashboard-modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(60,40,120,0.18);
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .dashboard-modal {
          background: #fff;
          border-radius: 18px;
          box-shadow: 0 8px 40px #a259ff33, 0 0 0 2px #4f8cff11;
          padding: 36px 32px 28px 32px;
          min-width: 320px;
          max-width: 95vw;
          position: relative;
        }
        .modal-close-btn {
          position: absolute;
          top: 12px;
          right: 18px;
          background: none;
          border: none;
          font-size: 2rem;
          color: #a259ff;
          cursor: pointer;
        }
        @media (max-width: 900px) {
          .dashboard-content {
            grid-template-columns: 1fr;
          }
          .quick-actions-btn-row {
            gap: 14px;
            flex-direction: column;
            align-items: stretch;
          }
        }
        .modal-form-row {
          display: flex;
          gap: 12px;
          margin-bottom: 12px;
          flex-wrap: wrap;
        }
        .zentora-input {
          font-family: 'FK Grotesk', sans-serif;
          font-size: 1.05rem;
          padding: 10px 16px;
          border-radius: 10px;
          border: 1.5px solid #e0dfff;
          background: #f7f6ff;
          color: #23273a;
          outline: none;
          transition: border 0.18s, box-shadow 0.18s;
          box-shadow: 0 2px 8px #a259ff11;
          margin-bottom: 0;
        }
        .zentora-input:focus {
          border: 1.5px solid #a259ff;
          box-shadow: 0 0 0 2px #a259ff22;
          background: #fff;
        }
        .zentora-input::placeholder {
          color: #b0b3c6;
          opacity: 1;
        }
        .zentora-btn, .modal-action-btn {
          font-family: 'FK Grotesk', sans-serif;
          background: #bbaaff;
          color: #fff;
          border: 1.5px solid #e0dfff;
          border-radius: 10px;
          font-size: 1.05rem;
          font-weight: 600;
          padding: 10px 28px;
          cursor: pointer;
          box-shadow: 0 4px 18px #a259ff22;
          transition: background 0.18s, transform 0.18s;
          margin-left: 0;
          margin-top: 10px;
          display: inline-block;
        }
        .zentora-btn:hover, .modal-action-btn:hover {
          background: #a084e8;
          transform: translateY(-2px) scale(1.04);
        }
        input[type="file"].zentora-input {
          padding: 8px 0;
          background: none;
          border: none;
          box-shadow: none;
        }
        /* Modal content tweaks */
        .dashboard-modal h3 {
          font-family: 'PP Editorial', serif;
          font-size: 1.25rem;
          color: #23273a;
          margin-bottom: 6px;
        }
        .dashboard-modal p {
          color: #8a8e9c;
          font-size: 1.01rem;
          margin-bottom: 16px;
        }
        .resource-center-fab {
          position: fixed;
          top: 50%;
          right: 36px;
          z-index: 1200;
          background: #fff;
          border: none;
          border-radius: 50%;
          box-shadow: 0 8px 32px #a259ff33, 0 0 0 2px #fff8;
          width: 64px;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.18s, box-shadow 0.18s, transform 0.18s;
          outline: none;
          padding: 0;
        }
        .resource-center-fab:hover, .resource-center-fab:focus {
          background: #f3f3f7;
          box-shadow: 0 12px 40px #a259ff44, 0 0 0 4px #a259ff22;
          transform: scale(1.07);
        }
        .resource-center-logo {
          width: 38px;
          height: 38px;
          object-fit: contain;
          filter: drop-shadow(0 8px 32px #a259ff44) drop-shadow(0 0 12px #fff8);
        }
        .resource-center-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(60,40,120,0.10);
          z-index: 1300;
          display: flex;
          align-items: stretch;
          justify-content: flex-end;
        }
        .resource-center-sidebar {
          width: 370px;
          max-width: 95vw;
          background: rgba(255,255,255,0.82);
          box-shadow: -8px 0 40px #a259ff33, 0 0 0 2px #4f8cff11;
          backdrop-filter: blur(18px) saturate(1.2);
          border-left: 2px solid #e9e6ff88;
          padding: 38px 32px 48px 32px;
          display: flex;
          flex-direction: column;
          gap: 18px;
          position: relative;
          animation: slidein 0.45s cubic-bezier(.4,0,.2,1);
          border-top-left-radius: 24px;
          border-bottom-left-radius: 24px;
        }
        @keyframes slidein {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: none; opacity: 1; }
        }
        .animate-slidein {
          animation: slidein 0.45s cubic-bezier(.4,0,.2,1);
        }
        .resource-center-close {
          position: absolute;
          top: 18px;
          right: 24px;
          background: none;
          border: none;
          font-size: 2.1rem;
          color: #a259ff;
          cursor: pointer;
          z-index: 10;
        }
        .resource-center-header {
          display: flex;
          align-items: center;
          gap: 18px;
        }
        .resource-center-header h2 {
          font-family: 'PP Editorial', serif;
          font-size: 1.5rem;
          color: #23273a;
          margin: 0;
        }
        .resource-center-sub {
          color: #8a8e9c;
          font-size: 1.01rem;
        }
        .resource-center-section {
          margin-top: 12px;
        }
        .resource-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .resource-list a {
          color: #4f8cff;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.18s;
        }
        .resource-list a:hover {
          color: #a259ff;
        }
        .ai-section {
          margin-top: 24px;
        }
        .ai-recommendation-card {
          background: linear-gradient(90deg, #f3f3f7 60%, #e9e6ff 100%);
          border-radius: 12px;
          box-shadow: 0 2px 12px #a259ff11;
          padding: 14px 18px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 0;
          font-size: 1.01rem;
        }
        .analytics-card {
          grid-column: 2 / 4;
          margin-top: -12px;
          background: rgba(255,255,255,0.68);
          box-shadow: 0 8px 40px #a259ff22, 0 0 0 2px #4f8cff11;
          backdrop-filter: blur(16px) saturate(1.2);
          border: 1.5px solid #e9e6ff88;
          padding: 32px 32px 24px 32px;
          display: flex;
          flex-direction: column;
          gap: 18px;
          position: relative;
          overflow: hidden;
          min-width: 0;
          animation: fadein 0.7s cubic-bezier(.4,0,.2,1);
        }
        .analytics-header {
          display: flex;
          align-items: center;
          gap: 18px;
        }
        .analytics-header-center {
          justify-content: center;
          width: 100%;
          margin-bottom: 8px;
        }
        .analytics-header-center-group {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 14px;
        }
        .analytics-header h2 {
          font-family: 'PP Editorial New Italic', 'PP Editorial', serif;
          font-size: 1.3rem;
          color: #23273a;
          margin: 0;
        }
        .analytics-charts-row {
          display: flex;
          justify-content: center;
          align-items: stretch;
          gap: 32px;
          margin-top: 10px;
          margin-bottom: 10px;
          width: 100%;
          flex-wrap: nowrap;
        }
        .analytics-chart {
          background: rgba(255,255,255,0.96);
          border-radius: 18px;
          box-shadow: 0 4px 24px #a259ff18, 0 0 0 2px #4f8cff11;
          padding: 28px 18px 18px 18px;
          flex: 1 1 0;
          min-width: 0;
          max-width: 340px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          position: relative;
          transition: box-shadow 0.18s, background 0.18s;
        }
        .analytics-chart:not(:last-child) {
          margin-right: 18px;
        }
        .chart-title {
          color: #4f8cff;
          font-size: 1.13rem;
          font-weight: 700;
          margin-bottom: 8px;
        }
        .chart-label {
          color: #a259ff;
          font-size: 1.05rem;
          font-weight: 700;
          margin-top: 8px;
        }
        .analytics-chart svg {
          display: block;
          margin: 0 auto;
          width: 80px;
          height: 48px;
          filter: drop-shadow(0 2px 8px #a259ff11);
        }
        .analytics-chart .chart-pie {
          width: 56px;
          height: 56px;
        }
        .analytics-chart {
          background: rgba(255,255,255,0.92);
          backdrop-filter: blur(8px) saturate(1.1);
          border: 1.5px solid #e0dfff;
        }
        .interactive-chart {
          cursor: pointer;
          transition: box-shadow 0.18s, transform 0.18s, background 0.18s;
        }
        .interactive-chart:hover, .interactive-chart:focus {
          box-shadow: 0 4px 24px #a259ff33, 0 0 0 2px #4f8cff33;
          background: linear-gradient(90deg, #f3f3f7 60%, #e9e6ff 100%);
          transform: translateY(-2px) scale(1.04);
        }
        .chart-svg {
          transition: filter 0.18s;
        }
        .interactive-chart:hover .chart-svg, .interactive-chart:focus .chart-svg {
          filter: drop-shadow(0 0 8px #a259ff66);
        }
        .analytics-insights {
          margin-top: 10px;
          background: linear-gradient(90deg, #f3f3f7 60%, #e9e6ff 100%);
          border-radius: 12px;
          box-shadow: 0 2px 12px #a259ff11;
          padding: 16px 18px 10px 18px;
        }
        .insights-title {
          color: #23273a;
          font-size: 1.08rem;
          font-weight: 700;
          margin-bottom: 8px;
        }
        .insights-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .insights-list li {
          color: #4f8cff;
          font-size: 1.01rem;
          display: flex;
          align-items: center;
          gap: 8px;
          position: relative;
        }
        .insight-glow {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: radial-gradient(circle, #a259ff 0%, #4f8cff 80%, #fff0 100%);
          box-shadow: 0 0 8px #a259ff88, 0 0 16px #4f8cff44;
          margin-right: 4px;
        }
        @media (max-width: 900px) {
          .analytics-card {
            grid-column: 1 / -1;
            padding: 18px 6vw 12px 6vw;
          }
          .analytics-charts-row {
            gap: 12px;
            flex-direction: column;
            align-items: stretch;
          }
          .analytics-chart {
            max-width: 100%;
            margin-right: 0 !important;
          }
        }
        .rounded-sidebar {
          border-top-left-radius: 24px;
          border-bottom-left-radius: 24px;
        }
        .faq-section {
          margin-top: 18px;
        }
        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .faq-item {
          background: #f7f6ff;
          border-radius: 9px;
          box-shadow: 0 1px 6px #a259ff11;
          padding: 12px 16px;
          cursor: pointer;
          transition: background 0.18s, box-shadow 0.18s, max-height 0.18s;
          max-height: 48px;
          overflow: hidden;
          outline: none;
        }
        .faq-item.open {
          background: linear-gradient(90deg, #f3f3f7 60%, #e9e6ff 100%);
          box-shadow: 0 2px 12px #a259ff22;
          max-height: 200px;
        }
        .faq-question {
          font-weight: 600;
          color: #4f8cff;
          font-size: 1.04rem;
        }
        .faq-answer {
          color: #23273a;
          font-size: 0.99rem;
          margin-top: 8px;
          opacity: 0.95;
          transition: opacity 0.18s;
        }
        .faq-item:not(.open) .faq-answer {
          opacity: 0;
          height: 0;
          margin: 0;
          pointer-events: none;
        }
        @media (max-width: 900px) {
          .resource-center-fab {
            right: 12px;
            width: 52px;
            height: 52px;
          }
          .resource-center-sidebar {
            width: 98vw;
            min-width: 0;
            padding: 28px 10px 38px 10px;
            border-top-left-radius: 18px;
            border-bottom-left-radius: 18px;
          }
         .faq-item {
           padding: 10px 8px;
         }
        }
        .resource-center-section h3 {
          font-family: 'FK Grotesk', sans-serif;
          font-size: 1.16rem;
          color: #4f8cff;
          font-weight: 800;
          margin-bottom: 10px;
          margin-top: 0;
        }
      `}</style>
    </div>
  );
} 